<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div style="min-width:900px;" class="mod-joylearning__courseinfo}">
      <!-- :inline="true" -->
        <div style="white-space:pre;  border-bottom:1px #ebeef5 solid">
      <el-form label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
          <el-row style="background-color:#ebecf0 !important">
              <div >
              <el-col :span="3"><div style="text-align:left;padding: 14px 12px;">
                  <span >{{$t('couse.applytitle')}}</span>
              </div></el-col>
              <el-col :span="20"><div style="text-align:center;padding: 15px 15px;"  >
               <span >{{this.$route.query.coursename}}</span>
              </div>
              </el-col> </div>
          </el-row>
<!--        <el-col :span="24" style="background-color:#ebecf0 !important">-->
<!--            <span >{{$t('couse.applytitle')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.$route.query.coursename}}</span>-->
<!--        </el-col>-->
      </el-form>
        </div>

      <!-- 表头动态展示
      是否 courseProjectCF 10 yes 20 no
      // 课程类型 courseKind  10 面授 20 驻店 30 远程
      // 品牌类型 courseBrand    10 BMW 20 BMW Moto 30 MINI 40 ZINORO 50 SF
      // 课程状态 coursestatus 10 未发布 20 已发布 30 已下架
       :row-style="{height:48+'px'}"
                :cell-style="{padding:0+'px'}"
     -->
      <el-table ref="multipleTable"
                v-loading="dataListLoading"
                :data="dataList"
                :border="true"
                style="width: 100%;margin-bottom: 20px;"

                >
        <!--style="height:527px; width: 100%;overflow:initial;"-->
<!--        <el-table-column type="selection"-->
<!--                         header-align="center"-->
<!--                         align="center"-->
<!--                         width="50">-->
<!--        </el-table-column>-->
        <!--序号-->
        <el-table-column :label="$t('couse.no')"
                         type="index"
                         :width="50"
                         align="center"
                         show-overflow-tooltip
                         fixed>
          <template slot-scope='scope'><span>{{(page-1)*limit + scope.$index+1}}</span></template>
        </el-table-column>
        <!--申请人-->
        <el-table-column prop="applyuserName"
                         :label="$t('couse.applyuserName')"
                         header-align="center"
                         align="center"
                         width="110"
                         show-overflow-tooltip
                         fixed></el-table-column>
          <!--年份-->
          <el-table-column prop="applyYear"
                           :label="$t('couse.applyYear')"
                           header-align="center"
                           align="center"
                           width="110"
                           show-overflow-tooltip
                           fixed></el-table-column>
        <!--所属经销商-->
        <el-table-column prop="orgName"
                         :label="$t('couse.applyorgName')"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         fixed></el-table-column>
        <!--期望授课城市-->
        <el-table-column prop="cityName"
                         :label="$t('couse.applycityName')"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         width="120"></el-table-column>
        <!--申请时间-->
        <el-table-column prop="applyDate"
                         :label="$t('couse.applyapplyDate')"
                         header-align="center"
                         align="center"
                         show-overflow-tooltip
                         width="180"></el-table-column>
        <!--审批人-->
        <el-table-column prop="approvalUserName"
                         :label="$t('couse.applyapprovalUserName')"
                         header-align="center"
                         align="center"
                         width="110"
                         show-overflow-tooltip
                         ></el-table-column>
        <!--审批时间  :formatter="createuserFormat" -->
        <el-table-column prop="approvalDate"
                         :label="$t('couse.applyapprovalDate')"
                         header-align="center"
                         show-overflow-tooltip
                         align="center"></el-table-column>
        <!--状态-->
        <el-table-column prop="approvalStatus"
                         :label="$t('couse.applyapprovalStatus')"
                         header-align="center"
                         show-overflow-tooltip
                         width="110"
                         align="center"
                         :formatter="approvalStatus"></el-table-column>
      </el-table>
      <!--      <el-pagination :current-page="page"-->
      <!--                     :page-sizes="[10, 20, 50, 100]"-->
      <!--                     :page-size="limit"-->
      <!--                     :total="total"-->
      <!--                     layout="total, sizes, prev, pager, next, jumper"-->
      <!--                     @size-change="pageSizeChangeHandle"-->
      <!--                     @current-change="pageCurrentChangeHandle">-->
      <!--      </el-pagination>-->
      <!-- 弹窗, 新增 / 编辑 -->

    </div>
  </el-card>
</template>

<script>
  // import Vue from 'vue'
  // import catalogtree from '../common/catalogtree'
  import mixinViewModule from '@/mixins/view-module'
  // import ToggleDiv from '@/components/toggle-div'
  // import ClassTree from '../common/class-tree/index'
  // import Tag from '@/components/learning/label-select/index'
  // import Tag from '@/components/learning/label-select/courselabel'
  // import AddOrUpdate from './courseinfo-add-or-update'
  export default {
    mixins: [mixinViewModule],
    data () {
      let _this = this
      return {
        tagInputShow: true,
        isShowLable: false,
        bussinessTypeChecked: null,
        isQueryShowLable: false,
        showOverflowTooltip: true,
        vehicleLabelShowFlg: true,
        openDelay: 300,
        showVehicleClassListVisible: [],
        showValueVisible: '',
        mixinViewModuleOptions: {
          getDataListURL: '/learning/courseinfo/courseDemandApplyinfo',
          getDataListIsPage: true,
        },
        dataList: [],
        // 是否 courseProjectCF
        newcourseProjectCF: _this.enums['courseProjectCF'],
        // 课程类型
        newcourseKind: _this.enums['courseKind'],
        // 品牌类型
        courseBrandArr: _this.enums['courseBrand'],
        // 课程状态
        newcoursestatus: _this.enums['courseStatus'],
        brandstr: '', // hiden
        createtime: '', // TODO
        courseMultipleSelection: [],
        dataForm: {
          catalogId: '', // 课程分类
          courseTeamCatalogId: '', // 课程团队分类
          courseTeamCatalogFirst: '',
          courseTeamCatalogSecond: '', // 课程团队分类
          courseId: '',
          courseBrand: [], // 品牌
          coursename: '', // 课程名称
          coursestatus: '', // 课程状态
          coursekind: '', // 课程类型
          courseLabel: '', // 课程标签
          collectiondemandflag: '', // 培训需求收集
          limitvisiableflag: '', // 是否限制学习
          createuser: '', // 创建人
          startTime: '',
          endTime: '',
          classroominfoList: '',
          courseTreeList: [], // 课程标签
          classRoomStatus: '',

        },

        // ],
        couresList: [], // 课程分类使用
        couresListVisible: false, // 课程分类使用
        catalogidList: [], // 课程团队分类用
        catalogidListVisible: false, // 课程团队分类用
        // 展示更多
        showBrand: true,
        userTableData: [],
        // 等待转圈
        dataListLoading: false,
        isShow: false,
        checkAll: false,
        brandQuery: [],
        // 设置按钮pop状态
        visible: false
      }
    },
    // components: {
    //   Tag,
    //   ToggleDiv,
    //   catalogtree,
    //   'class-tree': ClassTree
    // },
     created () {
          //this.mixinViewModuleOptions.getDataListURL = '/learning/courseBaseInfo/page'
         // this.mixinViewModuleOptions.getDataListIsPage = true
          this.quertCourse()
      },
    methods: {
        approvalStatus (row, column, cellValue) {
            if (cellValue === '20') {
                return '已通过'
            } else { return ' ' }
        },
        getDataList () {
            this.dataListLoading = true
            this.$request.get(
                this.mixinViewModuleOptions.getDataListURL,
                {  courseId:this.$route.query.courseId
                }
            ).then((res, total, code, data) => {
                console.log('11111111111111')
                console.log(data)
                let resultList = data.data
                this.dataList = resultList
                this.dataListLoading=false
                // 延迟加载 .data.records
                this.$nextTick(() => {
                  // nextTick
                })
            }).catch((err) => {
              console.log(err)
            })
        },
    }
  }
</script>
<style scoped>
  @import "../../../css/pkg-styles.css";
  .el-date-editor.el-input {
    width: 150px;
  }
  .search-item {
    width: 94%!important;
    min-width: 290px;
  }
  .el-row {
    margin-bottom: 0px;
  }
  .search {
    height: 50px;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
   .search-item .el-form-item__content {
    margin-left: 96px !important;
  }

  .link-type:focus {
    color: #337ab7;
    cursor: pointer;
  }
  .link-type:hover {
    color: rgb(32, 160, 255);
  }
  .link-label:hover{
    cursor: pointer;
    text-decoration: none !important;
  }
</style>
